import axiosInstance from 'ns_libs/nsAxios';
import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import invariant from 'helpers/invariant';

interface LatestInvestmentMemoRequest {
    organizationId: string;
    selectedProFormaOption?: {
        dealId: number;
        proFormaId: number;
    };
}

export type LatestInvestmentMemoResponse = {
    id: number;
    proFormaId: number;
    taskId: string | null;
    taskStatus: InvestmentMemoStatus;
    documentId: number | null;
    completedAt: string | null;
    viewedAt: string | null;
    createdAt: string;
}

export type InvestmentMemoStatus = 'PENDING' | 'COMPLETED' | 'FAILED';

const latestInvestmentMemo = async ({
    organizationId,
    selectedProFormaOption,
}: LatestInvestmentMemoRequest): Promise<LatestInvestmentMemoResponse> => {
    invariant(selectedProFormaOption, 'Selected pro forma option is required');

    const endpoint = `${API_ENDPOINTS.INVESTMENT_MEMO.LATEST(
        selectedProFormaOption.dealId,
        selectedProFormaOption.proFormaId,
    )}?organizationId=${organizationId}`;
    const response = await axiosInstance.get(endpoint);
    return response.data;
};

const useLatestInvestmentMemo = ({
    organizationId,
    selectedProFormaOption,
}: LatestInvestmentMemoRequest) => useQuery({
    queryKey: ['latestInvestmentMemo', organizationId, selectedProFormaOption?.dealId, selectedProFormaOption?.proFormaId],
    queryFn: () => latestInvestmentMemo({ organizationId, selectedProFormaOption }),
    retry: false,
    enabled: !!selectedProFormaOption,
});

export default useLatestInvestmentMemo;
